<template>
  <!-- Calendly inline widget begin -->
  <div class="calendly-inline-widget" :data-url="calendlyUrl" :style="calendlyStyles">
    <Spinner v-if="isLoading" />
  </div>
</template>

<script>
import { sendSlackDemoRequest } from '../../services/slackService/slackService';
import Spinner from '../Spinner.vue';

export default {
  components: {
    Spinner,
  },
  props: {
    stepData: Object,
  },
  data() {
    return {
      calendlyStyles: {
        width: '1155px',
        height: '800px',
      },
      isLoading: true,
    };
  },
  computed: {
    calendlyUrl() {
      const name = this.stepData ? this.stepData.first_name || '' : '';
      const email = this.stepData ? this.stepData.email : '';

      return `https://calendly.com/oversecured/30min?name=${name}&email=${email}`;
    },
  },
  mounted() {
    this.subscribeToCalendlyEvent();
    this.updateCalendlyStyles();

    window.addEventListener('resize', this.updateCalendlyStyles);

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    document.body.appendChild(script);

    const self = this;
    script.onreadystatechange = script.onload = function () {
      const widgetDiv = document.querySelector('.calendly-inline-widget');
      const iframe = widgetDiv.querySelector('iframe');

      iframe.addEventListener('load', function () {
        if (window.Calendly) {
          self.isLoading = false;

          window.addEventListener('message', self.handleCalendlyEvent);
        }
      });
    };
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateCalendlyStyles);
    this.unsubscribeFromCalendlyEvent();
  },
  methods: {
    handleCalendlyEvent(e) {
      const isCalendlyEvent =
        e.origin === 'https://calendly.com' &&
        e.data.event &&
        e.data.event.indexOf('calendly.') === 0;

      if (isCalendlyEvent && e.data.event === 'calendly.event_scheduled') {
        gtag('event', 'product_demo_request', {
          event_category: 'engagement',
          event_label: 'custom',
        });
        this.sendDataToAttio(e.data.payload);
      }
    },
    async sendDataToAttio(calendlyPayload) {
      const payload = {
        first_name: this.stepData.first_name || '',
        corporate_email: this.stepData.email,
        referral_source: this.stepData.referral_source || this.stepData.referralSource || '',
        reason_for_contact: 'I would like a product demo',
        source: 'Portal',
      };
      this.isLoading = true;
      try {
        await this.$store.dispatch('user/sendBusinessContact', payload);

        this.isLoading = false;
        this.successNotification('contactUsSend');
      } catch (error) {
        this.isLoading = false;
        console.log(error);
        this.failNotification();
      }
    },
    extractDomainFromEmail(email) {
      if (!email || typeof email !== 'string') {
        return '';
      }
      const parts = email.split('@');
      return parts.length === 2 ? parts[1] : '';
    },
    subscribeToCalendlyEvent() {
      window.addEventListener('message', this.handleCalendlyEvent);
    },
    unsubscribeFromCalendlyEvent() {
      window.removeEventListener('message', this.handleCalendlyEvent);
    },
    updateCalendlyStyles() {
      if (window.innerWidth <= 1520) {
        this.calendlyStyles.width = '100%';
      } else {
        this.calendlyStyles.width = '1155px';
      }
    },
  },
};
</script>
